(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ImageDataExtended', ImageDataExtended);

    ImageDataExtended.$inject = ['$resource'];

    function ImageDataExtended($resource) {
        return {
            uploadImage: uploadImage
        };

        function uploadImage(file, caption, albumInfo) {
            var resourceUrl = 'api/upload-image';

            return $resource(resourceUrl, {
                save: {
                    method: "POST"
                    //transformRequest: angular.identity,
                    //   headers: { 'Content-Type': undefined }
                }
            }, {});
        }

    }
})();
